import { FC } from "react";
import { Box, Button, Flex, Image } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const HeaderLanding: FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      as="header"
      position="absolute"
      top={0}
      left={0}
      width="100%"
      zIndex={10}
    >
      <Flex
        width="100%"
        px={8}
        justify="space-between"
        align="center"
        height="90px"
        py={4}
      >
        {/* <Image
          src="/images/Azul-Verde.png"
          alt="SISAN"
          cursor="pointer"
          onClick={() => navigate("/")}
        /> */}
        <Image
          src="/images/Azul-Verde.png"
          alt="SISAN"
          cursor="pointer"
          onClick={() => navigate("/")}
          maxH={{ base: "40px", md: "60px" }}
          height="auto"
          width="auto"
        />

        {/* <Flex gap={6} color="white" align="center"> */}
        <Flex gap={{ base: 2, md: 6 }} color="white" align="center"   display={{ base: "none", md: "flex" }} // <-- aqui: oculto em mobile
          flexShrink={0}>
          <Button
            variant="tertiary"
            color="white"
            onClick={() => navigate("/")}
          >
            Início
          </Button>
          <Button
            variant="tertiary"
            color="white"
            onClick={() => navigate("/documentos")}
          >
            Repositório de documentos
          </Button>
          <Button
            variant="secondary"
            bg="white"
            onClick={() => navigate("/login")}
          >
            Entrar
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default HeaderLanding;
